import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import UserContext from "../../../services/Context/UserContext"
import { Download } from "@mui/icons-material";

export default function VimeoButton({chapters, sections}){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)
    
    const {user} = useContext(UserContext)

    const [loading, setLoading] = useState(false);

    const handleClick = () => {

        setLoading(true)

        API.get(`/design/courses/${id}/vimeo/import`)
            .then(r => {
                chapters.refetch()
                sections.refetch()
            })
            .catch(e => setToast({
                severity: 'error',
                message: "Les vidéos n'ont pas pu être importées."
            }))
            .finally(() => setLoading(false))
    }

    return user.admin && 
        <LoadingButton
            startIcon={<Download />}
            loading={loading}
            onClick={handleClick}
        >
            Import Vimeo
        </LoadingButton>
}